export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_marketing-hub-583/artifacts/mapu1te3__logo_c2_advertising_logo_RGB.png";

export const NAV_LINKS = [
  { label: "Servicii", href: "#services" },
  { label: "Despre", href: "#about" },
  { label: "Proces", href: "#process" },
  { label: "Rezultate", href: "#stats" },
  { label: "Întrebări", href: "#faq" },
];

export const CONTACT = {
  email: "hello@c2advertising.ro",
  phone: "0727 014 425",
  phoneRaw: "+40727014425",
  domain: "c2advertising.ro",
  address: "România",
};

export const SERVICES = [
  {
    id: "google-ads",
    title: "Google Ads & PPC",
    tag: "Performance",
    accent: "electric",
    description:
      "Campanii Search, Performance Max, YouTube și Display construite pentru ROAS, nu pentru vanity metrics.",
    bullets: [
      "Audit cont & strategie de bidding",
      "Structură de campanii Search + PMax",
      "Tracking conversii server-side (GA4)",
      "Rapoarte săptămânale și optimizare continuă",
    ],
  },
  {
    id: "social-media",
    title: "Social Media Marketing",
    tag: "Brand & Performance",
    accent: "magenta",
    description:
      "De la strategie de conținut la reclame Meta și TikTok care construiesc comunitate și vânzări.",
    bullets: [
      "Strategie de conținut și calendar editorial lunar",
      "Setup & management Meta Business & TikTok Ads",
      "Optimizare audiențe, bidding și creative briefing",
      "Community management & raportare lunară",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Discovery",
    desc: "Audit complet al business-ului, conturilor de ads și concurenței. Înțelegem unde sunteți și unde vreți să ajungeți.",
  },
  {
    n: "02",
    title: "Strategie",
    desc: "Propunere clară: canale, bugete, KPI și roadmap pe 90 de zile. Fără promisiuni de marketing, doar plan executabil.",
  },
  {
    n: "03",
    title: "Execuție",
    desc: "Lansăm campaniile, producem creative și implementăm tracking-ul. Voi vedeți rezultate, nu slide-uri.",
  },
  {
    n: "04",
    title: "Optimizare",
    desc: "Testare săptămânală, scaling pe ce funcționează, raport lunar transparent cu pași concreți.",
  },
];

export const STATS = [
  { value: "150+", label: "Clienți serviți", accent: "magenta" },
  { value: "8.4M+", label: "EUR bugete gestionate", accent: "electric" },
  { value: "13", label: "Ani cu clienți fideli", accent: "magenta" },
  { value: "12+", label: "Industrii acoperite", accent: "electric" },
];

export const TESTIMONIALS = [
  {
    name: "Andreea Pop",
    role: "Founder, BloomBeauty",
    quote:
      "În 3 luni am dublat comenzile online prin Meta Ads. Echipa C2 e directă, nu se ascunde după jargon — testează rapid și raportează clar.",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MDY0NjIyOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Mihai Stoian",
    role: "CEO, NorthGear",
    quote:
      "Au restructurat complet contul Google Ads și au scăzut CPA cu 41% în prima lună. Prima agenție care chiar înțelege Performance Max.",
    avatar:
      "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MDY0NjIyOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Ioana Marin",
    role: "Marketing Lead, Casa Verde",
    quote:
      "Conținutul social este alt nivel — coerent, brand-aligned, cu engagement real. Recomand fără rezerve.",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4MDY0NjIyOHww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Care este bugetul minim recomandat pentru Google Ads?",
    a: "Recomandăm un buget media de cel puțin 1.500 EUR / lună pentru a avea date suficiente de optimizare. Pentru nișe foarte specifice putem începe și mai jos — discutăm în prima ședință.",
  },
  {
    q: "În cât timp văd rezultate?",
    a: "Primele lead-uri sau vânzări apar de obicei în 2-4 săptămâni. Optimizarea reală și scalarea durează 60-90 de zile, în funcție de industrie și buget media.",
  },
  {
    q: "Lucrați cu contract pe termen lung?",
    a: "Lucrăm cu contracte lunare, fără bilet de intrare. Credem că rezultatele ne țin clienții, nu clauzele.",
  },
  {
    q: "Cine produce creative-urile pentru reclamele de Social Media?",
    a: "Nu avem echipă internă de design/video, dar îți ghidăm clar brieful: layout, hook, call-to-action, formate. Lucrăm cu echipa ta internă, cu freelanceri sau cu un partener de încredere — și ne asigurăm că livrabilele respectă cerințele platformelor și performanța campaniilor.",
  },
  {
    q: "Oferiți și consultanță fără execuție?",
    a: "Nu. Lucrăm doar pe proiecte în care preluăm și execuția — Google Ads și/sau Social Media Ads. Așa putem garanta rezultatele și asuma responsabilitatea completă pentru KPI-uri.",
  },
  {
    q: "Cum arată raportarea?",
    a: "Dashboard live (Looker Studio) cu KPI-urile agreate + raport lunar scris cu interpretare și pași următori. Fără PDF-uri lungi pe care nu le citește nimeni.",
  },
];

export const SERVICE_OPTIONS = [
  "Google Ads & PPC",
  "Social Media Marketing",
  "Ambele",
  "Nu sunt sigur încă",
];

export const BUDGET_OPTIONS = [
  "< 1.000 EUR / lună",
  "1.000 - 3.000 EUR / lună",
  "3.000 - 7.000 EUR / lună",
  "7.000+ EUR / lună",
  "Nu sunt sigur",
];
